export default __webpack_public_path__ + "static/media/iToken LM.34c28a96.svg";